export default __webpack_public_path__ + "static/media/faq-ico.3900989d.svg";